import dayjs from 'dayjs';
import { useEffect } from 'react';
import { Store } from '../store/index';

export const useMessageChime = () => {
  const audio = new Audio('http://codeskulptor-demos.commondatastorage.googleapis.com/pang/pop.mp3');

  const toggle = () => {
    audio.play;
  };
  useEffect(() => {
    audio.addEventListener('ended', () => audio.pause());
    return () => {
      audio.removeEventListener('ended', () => audio.pause());
    };
  }, []);

  return toggle;
};

export const setIntroField = (field: string, value: string) => {
  if (localStorage.getItem('introMessages')) {
    const parsedIntroMessage = JSON.parse(localStorage.getItem('introMessages') as string);
    parsedIntroMessage[field] = value;
    localStorage.setItem('introMessages', JSON.stringify(parsedIntroMessage));
  }
};

export const getIntroField = (field: string) => {
  if (localStorage.getItem('introMessages')) {
    const parsedIntroMessage = JSON.parse(localStorage.getItem('introMessages') as string);
    return parsedIntroMessage[field];
  }
  return null;
};

export const clearIntroFields = () => {
  localStorage.removeItem('introMessages');
  Store.update((s) => {
    s.skippedEmail = false;
  });
};
export const initializeIntroStorage = () => {
  const initialState = JSON.stringify({ startTime: dayjs().toISOString() });
  if (!localStorage.getItem('introMessages')) {
    localStorage.setItem('introMessages', initialState);
  } else {
    const parsedIntroMessage = JSON.parse(localStorage.getItem('introMessages') as string);
    if (parsedIntroMessage?.startTime) {
      if (dayjs().diff(dayjs(parsedIntroMessage.startTime), 'day') > 7) {
        localStorage.setItem('introMessages', initialState);
      }
    }
  }
};
